import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-pagination-component',
  imports: [NgClass],
  templateUrl: './pagination-component.html',
  styleUrl: './pagination-component.scss',
})
export class PaginationComponent implements OnChanges {
  @Input() totalItems: number = 100;
  @Input() itemsPerPage: number = 10;
  @Input() currentPage: number = 1;
  @Input() maxPagesToShow: number = 5;

  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  totalPages: number = 1;
  pages: number[] = [];

  ngOnChanges() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.pages = this.generatePages();
  }

  generatePages(): number[] {
    const pages: number[] = [];
    let start = Math.max(1, this.currentPage - Math.floor(this.maxPagesToShow / 2));
    let end = start + this.maxPagesToShow - 1;

    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(1, end - this.maxPagesToShow + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.pageChange.emit(this.currentPage);
    this.pages = this.generatePages();
  }

  changeItemsPerPage(event: Event) {
    const value = +(event.target as HTMLSelectElement).value;
    this.itemsPerPage = value;
    this.currentPage = 1;
    this.itemsPerPageChange.emit(this.itemsPerPage);
    this.pageChange.emit(this.currentPage);
    this.pages = this.generatePages();
  }
}
